import { useQuery } from '@apollo/client';
// Api
import { GET_ALL_HOME_PAGE_DATA_V2 } from 'api/homePage/queries';
// Types
import type { GetAllHomePageData } from 'api/homePage/types/GetAllHomePageData';

export const useGetAllHomePageData = () => {
  const { data, refetch, loading, error } = useQuery<GetAllHomePageData>(
    GET_ALL_HOME_PAGE_DATA_V2
  );

  return {
    data,
    refetch,
    loading,
    error,
  };
};
